const processFormErrorMessages = (validatedFormFields, formFieldsValues) => {
  if (validatedFormFields.errors) {
    formFieldsValues.forEach((field, index) => {
      if (field.name === validatedFormFields.params.path) {
        formFieldsValues[index].errorMessage = validatedFormFields.message;
      } else {
        formFieldsValues[index].errorMessage = '';
      }
    });
  } else {
    formFieldsValues.forEach((field, index) => {
      if (field.errorMessage) {
        formFieldsValues[index].errorMessage = '';
      }
      formFieldsValues[index].value = validatedFormFields[field.name];
    });
  }

  return {
    errors: validatedFormFields.errors,
    fields: formFieldsValues
  };
};

export default processFormErrorMessages;
